export default __webpack_public_path__ + "static/media/EngineeringTonic.6208fda78c8c5ff9ff6528c22cdada13.webp";